import { Subscription } from 'rxjs';
import {Component, OnDestroy } from "@angular/core";
import * as Communication from "../communication/index";
import {Config} from "../../environments/environment";
import { NgForm } from "@angular/forms";
import {NotificationService} from "../shared/common/NotificationService";
import { ActivatedRoute } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Authorization} from "../shared/authorization/authorization.component";

import { AuthorizationNotifier } from "@openid/appauth/built/authorization_request_handler";
import { LocalStorageBackend } from "@openid/appauth/built/storage";
import { NoHashQueryStringUtils } from './noHashQueryStringUtils';
import { DefaultCrypto } from "@openid/appauth/built/crypto_utils";
import { RedirectRequestHandler } from "@openid/appauth/built/redirect_based_handler";
import { BaseTokenRequestHandler } from "@openid/appauth/built/token_request_handler";
import { FetchRequestor } from "@openid/appauth/built/xhr";
import { AuthorizationServiceConfiguration } from "@openid/appauth/built/authorization_service_configuration";
import { AuthorizationRequest } from "@openid/appauth/built/authorization_request";
import { TokenRequest } from "@openid/appauth/built/token_request";

@Component({
    selector: 'sd-authgluu',
    templateUrl: 'authgluu.component.html',
    styleUrls: ['authgluu.component.css'],
    providers: [Communication.UsersService],
    standalone: false
})
export class AuthGluuComponent implements OnDestroy {

  imzayeriLogoUrl:string = Config.IDENTITY_PROVIDER_LOGO;
  title:string = "";
  subscriptions:Subscription[] = [];
  mode:string = "LOGIN";
  forgotPasswordCode:string = "";

  showResetPasswordError:boolean = false;
  resetPasswordErrorText:string = "";

  showRegisterPasswordError:boolean = false;
  registerPasswordErrorText:string = "";

  resetPasswordFirst:string = "";
  registerPasswordFirst:string = "";

  passwordErrorUppercase:boolean = true;
  passwordErrorLowerCase:boolean = true;
  passwordErrorNumber:boolean = true;
  passwordErrorSpecial:boolean = true;

  passwordResetLoading:boolean = false;
  loginLoading:boolean = false;
  registerLoading:boolean = false;
  forgotLoading:boolean = false;

  forgotPasswordButtonDisabled:boolean = false;

  authorizationHandler:any = null;
  tokenHandler:any = null;
  notifier:any = null;
  configuration:any = null;
  code:any = null;
  request:any = null;
  response:any = null;

  termsOfUseLink:string = Config.TERMS_OF_USE_LINK;

  constructor(
    private usersApi: Communication.UsersService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private authorization: Authorization,
  ) {

    this.title = Config.TITLE;

    this.authorizationHandler = new RedirectRequestHandler(
      new LocalStorageBackend(),
      new NoHashQueryStringUtils(),
      window.location,
      new DefaultCrypto()
    );

    this.tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
    this.notifier = new AuthorizationNotifier();
    this.authorizationHandler.setAuthorizationNotifier(this.notifier);

    this.notifier.setAuthorizationListener((request:any, response:any, error:any) => {
      console.log('Authorization request complete ', request, response, error);
      this.loginLoading = false;

      if (response) {
        this.request = request;
        this.response = response;
        this.code = response.code;
        console.log(`Authorization Code  ${response.code}`);

        let extras:any = null;
        if (this.request && this.request.internal) {
          extras = {};
          extras.code_verifier = this.request.internal.code_verifier;
        }

        const tokenRequest = new TokenRequest({
          client_id: Config.WEB_CLIENT_ID,
          redirect_uri: Config.WEB_APP_URL,
          grant_type: "authorization_code",
          code: this.code,
          refresh_token: undefined,
          extras
        });

        AuthorizationServiceConfiguration.fetchFromIssuer(Config.IDENTITY_PROVIDER_URL, new FetchRequestor())
          .then((oResponse: any) => {
            this.configuration = oResponse;
            return this.tokenHandler.performTokenRequest(this.configuration, tokenRequest);
          })
          .then((oResponse) => {
            console.log(oResponse)
            this.subscriptions.push(
              this.usersApi.usersLoginGet(
                oResponse.idToken,
                oResponse.accessToken
              ).subscribe(
                (response:any) => {
                  console.log(response);
                  let language = response.user.language;
                  let accountJson = response.user.subscription;
                  let account = {language:language,subscription:accountJson};
                  let profile = response.user;
                  profile.user_metadata = {
                    name:profile.name,
                    email:profile.email,
                    title:profile.title,
                    company:profile.company,
                    address:profile.address,
                    country:profile.country,
                    language:profile.language
                  }
                  localStorage.setItem('profile',JSON.stringify(profile));
                  localStorage.setItem('account',JSON.stringify(account));
                  localStorage.setItem('access_token',response.access_token);
                  localStorage.setItem('access_token_ip',oResponse.accessToken);
                  localStorage.setItem('refresh_token',oResponse.refreshToken);
                  localStorage.setItem('access_token_ip_exp',Math.round(((Date.now() / 1000) + 300)).toString());

                  // A deactivated account can still read GET /users but nothing else, so without
                  // this the sign-in completes and then fails on whatever the user clicks first.
                  // This is the sign-in the application actually uses; the same check in
                  // Authorization covers the paths that go through it.
                  if (this.authorization.rejectDeactivatedAccount(profile)) { return; }

                  location.href="/docs";
                },
                (error:any) => {
                  this.loginLoading = false;

                  // A deactivated account is refused here rather than signed in, so this is the
                  // branch that has to recognise it — the success callback above never runs.
                  if (this.authorization.rejectDeactivatedSignIn(error)) { return; }

                  let json = error.error;
                  if(json.code == 214){
                    console.log("Invalid Credentials");
                    this.notificationService.showInvalidCredentialsForLoginAlert();
                  } else if(json.code == 217){
                    console.log("Email Not Verified");
                    this.notificationService.showEmailNotVerifiedInfo(() => {
                      this.cleanupAndRedirect();
                    });
                  } else if(json.code == 203){
                    console.log("Server Error.");
                    this.notificationService.serverNotReachable();
                  } else if(json.code == 269){
                    this.notificationService.showEmailCanNotBeUsed(() => {
                      this.cleanupAndRedirect(true);
                    });
                  } else if (json.code == 206){
                    this.notificationService.showServerNotReachable(() => {
                      this.cleanupAndRedirect();
                    });
                  }
                  else {
                    console.log("Invalid Credentials");
                    this.notificationService.displayError(error);
                  }
                }
              )
            )
          })
          .catch(oError => {
            console.error('Token exchange error:', oError);
            this.loginLoading = false;
            this.cleanupLocalStorage();
            this.notificationService.displayError(oError);
          });
      }
    });

    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        console.log(params)
        if(params["after_logout"] != undefined && params["after_logout"] == "true"){
          this.onLoginSubmit();
          return;
        }
        if(params["fcode"] != undefined && params["fcode"] != ""){
          this.forgotPasswordCode = params['fcode'];
          this.mode = "RESET_PASSWORD";
        }
        if(params["code"] != undefined && params["code"] != ""){
          this.code = params["code"];
          this.loginLoading = true;

          // Call the protected method directly to detect null result
          (this.authorizationHandler as any).completeAuthorizationRequest()
            .then((result: any) => {
              if (!result) {
                // Null result - authorization failed (state mismatch, missing data, etc.)
                console.error('Authorization request returned null - possible state mismatch or stale data');
                this.loginLoading = false;
                this.cleanupLocalStorage();
                this.notificationService.showInvalidCredentialsForLoginAlert();
              } else {
                // Manually trigger the notifier with the result
                if (this.notifier) {
                  this.notifier.onAuthorizationComplete(result.request, result.response, result.error);
                }
                // loginLoading will be cleared in the notifier callback (line 91)
              }
            })
            .catch((error: any) => {
              console.error('Authorization error:', error);
              this.loginLoading = false;
              this.cleanupLocalStorage();
              this.notificationService.displayError(error);
            });

        }
        if(params["pwres"] != undefined && params["pwres"] == "yes"){
          this.mode = "FORGOT_PASSWORD";
        }
      })
    );

    if(this.mode != "RESET_PASSWORD" && authorization.authenticated()){
      location.href="/docs";
    }
  }

  onRegisterSubmit(form:NgForm){
    const accountStr = localStorage.getItem("account");
    let language: string = navigator.language;
    if (accountStr) {
      try {
        const account = JSON.parse(accountStr);
        language = account?.language || navigator.language;
      } catch (e) {
        console.warn('Failed to parse account from localStorage:', e);
      }
    }
    // API accepts only primary subtags (tr|en); browser may report e.g. "en-GB"
    language = (language || '').split('-')[0].toLowerCase();
    if (!/^(tr|en)$/.test(language)) {
      language = 'en';
    }

    if(!/^(?=.*[a-z])(?=.*[0-9]).{8,}$/.test(this.registerPasswordFirst)){
      this.showRegisterPasswordError = true;
      this.registerPasswordErrorText = this.translate.instant("Please enter a stronger password.");
      return;
    }

    let self = this;
    this.registerLoading = true;
    this.subscriptions.push(
      this.usersApi.usersRegisterPost(
        form.value.email,
        form.value.fullname,
        form.value.password,
        language,
        form.value.mobile
      ).subscribe(
        (response:any) => {
          this.notificationService.showEmailNotVerifiedInfo(function() {
            self.registerLoading = false;
            location.reload();
          });
        },
        (error: any) => {
          this.registerLoading = false;
          const errorJson = error.error || {};
          if (errorJson.code === 409) {
            console.log("User already exist");
            this.notificationService.showUserAlreadyExistsForRegisterAlert();
          } else {
            console.log(error);
            this.notificationService.displayError(error);
          }
        }
      )
    )
  }

  onLoginSubmit(){
    AuthorizationServiceConfiguration.fetchFromIssuer(Config.IDENTITY_PROVIDER_URL, new FetchRequestor())
      .then((response: any) => {
        this.configuration = response;
        const authRequest = new AuthorizationRequest({
          client_id: Config.WEB_CLIENT_ID,
          redirect_uri: Config.WEB_APP_URL,
          scope: "openid profile email user_name group_info",
          response_type: "code id_token token",
          state: this.generateRandomString(32),
          extras: {
            "nonce": this.generateRandomString(32),
            "response_mode": "query",
            "ui_locales": Config.UI_LOCALE
          }
        });
        this.authorizationHandler.performAuthorizationRequest(this.configuration, authRequest);
      })
      .catch(error => {
        console.error('Failed to fetch authorization configuration:', error);
        this.loginLoading = false;
        this.notificationService.serverNotReachable();
      });
  }

  onForgotPasswordSubmit(form:NgForm){
    this.forgotLoading = true;
    this.subscriptions.push(
      this.usersApi.usersResetPasswordPost(
        form.value.emailForgotPassword
      ).subscribe(
        (response) => {
          this.forgotLoading = false;
          this.forgotPasswordButtonDisabled = true;
          this.notificationService.passwordChangeSent(form.value.emailForgotPassword);
        },
        (error: any) => {
          this.forgotLoading = false;
          const errorJson = error.error || {};
          if (errorJson.code === 210) {
            this.notificationService.showNoUserFoundAlert();
          } else {
            this.notificationService.displayError(error);
          }
        }
      )
    )
  }

  onResetPasswordSubmit(form:NgForm){
    let pwd = form.value.passwordReset;
    let pwdAgain = form.value.passwordResetAgain;

    if(pwdAgain !== pwd){
      this.showResetPasswordError = true;
      this.resetPasswordErrorText = this.translate.instant("Passwords does not match.");
      return;
    }

    // Strong Password REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&./\*]).{8,}$/

    if(!/^(?=.*[a-z])(?=.*[0-9]).{8,}$/.test(pwd)){
      this.showResetPasswordError = true;
      this.resetPasswordErrorText = this.translate.instant("Please enter a stronger password.");
      return;
    }

    this.passwordResetLoading = true;

    this.subscriptions.push(
      this.usersApi.usersResetPasswordCodePut(
        this.forgotPasswordCode,
        pwd
      ).subscribe(
        (response) => {
          this.passwordResetLoading = false;
          this.showResetPasswordError = false;
          let self = this;
          this.notificationService.passwordChangedSuccessfully(
            function(isConfirmed:boolean){
              if(isConfirmed){
                if(localStorage.getItem("profile") == null){
                  localStorage.clear();
                  window.location.href = Config.WEB_APP_URL
                } else {
                  self.authorization.logout();
                }
              }
            }
          )
        },
        (error: any) => {
          this.passwordResetLoading = false;
          this.showResetPasswordError = false;
          const errorJson = error.error || {};
          if (errorJson.code === 210) {
            this.notificationService.showNoUserFoundAlert();
          } else if (errorJson.code === 216) {
            this.notificationService.passwordNotSuitable();
          } else if (errorJson.code === 270) {
            this.notificationService.resetCodeUsedOrNotValid();
          } else {
            this.notificationService.displayError(error);
          }
        }
      )
    )
  }

  onPasswordInputChange(){
    let pwd;
    if(this.mode === "REGISTER"){
      pwd = this.registerPasswordFirst;
    } else if (this.mode === "RESET_PASSWORD"){
      pwd = this.resetPasswordFirst;
    }

    // this.passwordErrorUppercase = !/(?=.*[A-Z])/.test(pwd);
    this.passwordErrorLowerCase = !/(?=.*[a-z])/.test(pwd);
    this.passwordErrorNumber = !/(?=.*[0-9])/.test(pwd);
    // this.passwordErrorSpecial = !/(?=.*[!@#\$%\^&./\*])/.test(pwd);
  }

  private generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomValues = new Uint8Array(length);
    crypto.getRandomValues(randomValues);
    return Array.from(randomValues, v => chars[v % chars.length]).join('');
  }

  private cleanupLocalStorage(): void {
    // Clean app-specific tokens and data
    localStorage.removeItem('access_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('account');
    localStorage.removeItem('access_token_ip');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token_ip_exp');

    // Clean AppAuth library keys
    const handle = localStorage.getItem('appauth_current_authorization_request');
    if (handle) {
      localStorage.removeItem('appauth_current_authorization_request');
      localStorage.removeItem(`${handle}_appauth_authorization_request`);
      localStorage.removeItem(`${handle}_appauth_authorization_service_configuration`);
    }
  }

  private cleanupAndRedirect(afterLogout: boolean = false): void {
    this.cleanupLocalStorage();
    const redirectUrl = afterLogout
      ? Config.LOGOUT_ENDPOINT + "?post_logout_redirect_uri=" + Config.WEB_APP_URL + "?after_logout=true"
      : Config.LOGOUT_ENDPOINT + "?post_logout_redirect_uri=" + Config.WEB_APP_URL;
    window.location.href = redirectUrl;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
  }

}
